module.exports = __webpack_public_path__ + "static/media/image1.8a6607d5.png";